import { Tokens } from '@tmov/design-system/theme/types';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;

  width: 100%;
  min-height: 100%;
  padding: 72px;
  overflow: scroll;

  background: #f1f4f5;
`;

export const Header = styled.div`
  margin-bottom: 32px;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CardContent = styled.div`
  margin-bottom: 24px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 32px;
`;

export const HeaderLeft = styled.div``;

export const ContainerBody = styled.div`
  display: ${props => (props.loading ? 'none' : 'initial')};
`;
